import { ComponentType } from 'react';

import { translate } from '../../../../../common/helpers/translate.helper';
import { IconCircleCheck } from '../../../../../common/icons/cdl/CircleCheck';
import { IconCircleDotted } from '../../../../../common/icons/cdl/CircleDotted';
import { IconCircleX } from '../../../../../common/icons/cdl/CircleX';
import { OfferModel } from '../../../../../offer/model/OfferModel';
import { OfferState } from '../../../../../offer/model/OfferState';
import { MetaInformationProps } from '../../../common/OfferCard/MetaInformation';

interface RfqOfferStatusInfo {
    label: string;
    variant: MetaInformationProps['variant'];
    Icon: ComponentType<{ width?: number; height?: number }>;
}

const defaultStatus: RfqOfferStatusInfo = {
    label: translate('order.detail.offerCard.quoted'),
    variant: 'accent',
    Icon: IconCircleCheck,
};

export const getRfqOfferStatus = (offer: OfferModel, isClosed: boolean): RfqOfferStatusInfo => {
    if (offer.isOrder() && !isClosed) {
        return {
            label: translate('order.detail.offerCard.ordered'),
            variant: 'positive',
            Icon: IconCircleCheck,
        };
    }

    switch (offer.state) {
        case OfferState.ENQUIRY:
            return {
                label: translate('order.detail.offerCard.waitingForQuoteUpdate'),
                variant: 'attention',
                Icon: IconCircleDotted,
            };
        case OfferState.QUOTE_DECLINED:
            return isClosed
                ? {
                      label: offer.isSpot()
                          ? translate('rfq.detail.offerCard.spotQuoteDeclined')
                          : translate('rfq.detail.offerCard.quoteDeclined'),
                      variant: 'neutral',
                      Icon: IconCircleX,
                  }
                : defaultStatus;
        case OfferState.QUOTE_CANCELED:
            return isClosed
                ? {
                      label: offer.isSpot()
                          ? translate('rfq.detail.offerCard.spotQuoteDeclined')
                          : translate('rfq.detail.offerCard.quoteCanceled'),
                      variant: 'neutral',
                      Icon: IconCircleX,
                  }
                : defaultStatus;
        case OfferState.ENQUIRY_DECLINED:
            return isClosed
                ? {
                      label: translate('rfq.detail.offerCard.canceled'),
                      variant: 'neutral',
                      Icon: IconCircleX,
                  }
                : defaultStatus;
        case OfferState.ENQUIRY_CANCELED:
            return isClosed
                ? {
                      label: translate('rfq.detail.offerCard.enquiryCanceled'),
                      variant: 'neutral',
                      Icon: IconCircleX,
                  }
                : defaultStatus;
        case OfferState.ENQUIRY_EXPIRED:
            return isClosed
                ? {
                      label: offer.isSpot()
                          ? translate('rfq.detail.offerCard.spotEnquiryExpired')
                          : translate('rfq.detail.offerCard.enquiryExpired'),
                      variant: 'neutral',
                      Icon: IconCircleX,
                  }
                : defaultStatus;
        default:
            return defaultStatus;
    }
};
